<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Detalles plantilla</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <!-- Reference -->
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Referencia"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  :disabled="true"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-row>
              <b-col :col="12">
                <label>Características</label>
                <ul class="list">
                  <li>
                    Atributos ({{ form.definition.attributes.length }}):
                    {{
                      form.definition.attributes
                        .map((x) => {
                          return x.reference;
                        })
                        .join(', ')
                    }}
                  </li>
                  <li>
                    Vistas ({{ form.definition.views.length }}):
                    {{
                      form.definition.views
                        .map((x) => {
                          return x.label;
                        })
                        .join(', ')
                    }}
                  </li>
                </ul>
              </b-col>
            </b-row>

            <b-form-row>
              <b-form-group
                id="input-options"
                label="Definición"
                label-for="options"
                class="col-12"
              >
                <b-form-textarea
                  :disabled="true"
                  rows="10"
                  id="definition"
                  v-model="$v.form.definition.$model"
                  :state="validateState('definition')"
                  aria-describedby="input-definition-feedback"
                ></b-form-textarea>
                <b-form-invalid-feedback id="input-definition-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <!-- <b-button type="submit" variant="primary"
              >Guardar selector</b-button
            > -->
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';

import {
  required,
  minLength,
  decimal,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminProductSelectorsEditScreen',
  props: ['reference'],
  components: { Multiselect },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },
      definition: {
        required,
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      reference: '',
      definition: '',
      error: {
        show: false,
        text: '',
      },
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    actions.getProductTemplate(this.reference).then((x) => {
      this.form.reference = x.data.reference;
      this.form.definition = x.data.definition;

      this.loadSelectedAttributeOptions(x.data.attribute);
    });
  },
  computed: {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {
        reference: this.form.reference,
        attribute: this.form.attribute,
        options: this.form.options,
      };

      actions.patchProductSelector(this.reference, data).then((x) => {
        this.$router.push({ name: 'AdminProductSelectorsScreen' });
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
